import { render, staticRenderFns } from "./FooterBox.vue?vue&type=template&id=dae8bbe0&scoped=true&"
import script from "./FooterBox.vue?vue&type=script&lang=js&"
export * from "./FooterBox.vue?vue&type=script&lang=js&"
import style0 from "./FooterBox.vue?vue&type=style&index=0&id=dae8bbe0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dae8bbe0",
  null
  
)

export default component.exports